import PortfolioInvestmentsError from '../PortfolioInvestmentsError';
class BricksInvestmentsNotFound extends PortfolioInvestmentsError {
    constructor(options) {
        super('The bricks investments detail is not found', options);
    }
}
export default BricksInvestmentsNotFound;
